var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "goodsClickLog",
    },
    [
      _c("div", { staticClass: "goodsClickLogTitle" }, [
        _vm._v("商品点击"),
        _c("i", {
          staticClass: "el-icon-close fr pointer",
          on: { click: _vm.close },
        }),
      ]),
      _c(
        "div",
        { staticClass: "myTable" },
        [
          _c(
            "el-table",
            {
              staticStyle: { widht: "566px" },
              attrs: {
                data: _vm.list,
                "header-cell-style": { background: "#F3F3F3" },
                "max-height": "300px",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "goodsName", label: "商品名称" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsPrice",
                  label: "商品原价",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("filtersMoneyByZero")(row.goodsPrice)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operateTime",
                  label: "点击时间",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("parseTime")(
                                row.operateTime,
                                "{y}-{m}-{d} {h}:{i}"
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }